// extracted by mini-css-extract-plugin
export var buttonContainer = "_2w-6";
export var centeredToolbar = "_2w-4";
export var dashdraw = "_2w-c";
export var emptyStateContainer = "_2w-8";
export var emptyStateText = "_2w-9";
export var flowEditor = "_2w-0";
export var flowEditorContainer = "_2w-7";
export var hovered = "_2w-1";
export var leftPanel = "_2w-3";
export var mainCanvasContainer = "_2w-a";
export var minimap = "_2w-b";
export var selectMode = "_2w-2";
export var toolbarSeparator = "_2w-5";